//Add code to run on JS init
export const initJS = () => {
	//First thing to do is to update to remove the no JS flag
	document.querySelector('.no-js').classList.remove('no-js');
}
initJS();